import { Label, TextInput } from "flowbite-react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ModalFormTextInputProps {
    register: UseFormRegisterReturn,
    errors: Record<string, any>,
    fieldName: string,
    label: string,
    placeholder: string
}

const ModalFormTextInput = ({register, errors, fieldName, label, placeholder}: ModalFormTextInputProps) => {
    return (
        <div>
            <div className="mb-2 block">
                <Label htmlFor={fieldName} value={label} />
            </div>
            <TextInput
                id={fieldName}
                placeholder={placeholder}
                {...register}
            />
            {errors && errors[fieldName] && (
                <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
            )}
        </div>
    )
}

export default ModalFormTextInput;